//Theme custom functions
jQuery( function( $ ) {
	var bottom_of_object, bottom_of_window;
	$( document ).ready( function() {

		$( '.menu-icon' ).click( function() {
			if ( $( '.menu-icon' ).hasClass( 'active' ) ) {
				$( '.nav' ).removeClass( 'show' );
				$( '.menu-icon' ).removeClass( 'active' );
				$('section').css('filter', 'unset');


			} else {
				$( '.menu-icon' ).addClass( 'active' );
				$( '.nav' ).addClass( 'show' );
				$( 'header' ).addClass( 'fixed' );
				$('section').css('filter', 'blur(5px)');
			}
		} );

		$( 'header .nav a' ).click( function() {
			$( '.nav' ).removeClass( 'show' );
			/*$( '.menu-icon' ).removeClass( 'active' );
			var element = $( this ).attr( 'href' );
			event.preventDefault();
			$( 'html, body' ).animate( {
				scrollTop: $( element ).offset().top - 100,
			}, 800 );*/
		} );

		//Testimonials
		var sliderCoupons = new Swiper('.swiper' , {
			slidesPerView: 1,
			direction: 'horizontal',
			spaceBetween: 15,
			loop: true,
			autoplay: true,
			centeredSlides: true,
			pauseOnMouseEnter: true,
			pagination: {
			  el: '.swiper-pagination',
			  clickable: true,
		  },
		});

		//$('.floating-img').enllax();
		$(window).enllax();
	} );

	addAnim();
	$( window ).scroll( function() {
	   addAnim();
	} );

	function addAnim() {
		$( '.anim' ).each( function( i ) {
			bottom_of_object = $( this ).offset().top + $( this ).outerHeight() - 250;
			bottom_of_window = $( window ).scrollTop() + $( window ).height();
			if ( bottom_of_window > bottom_of_object ) {
				$( this ).addClass( 'play' );
			}
		} );
	}

/* SHOW/HIDE header plugin */
	var mainHeader = $( '.cd-auto-hide-header' ),
		secondaryNavigation = $( '.cd-secondary-nav' ),
		belowNavHeroContent = $( '.sub-nav-hero' ),
		headerHeight = mainHeader.height();

	//set scrolling variables
	var scrolling = false,
		previousTop = 0,
		scrollDelta = 10,
		scrollOffset = 150;

	mainHeader.on( 'click', '.nav-trigger', function( event ) {
	// open primary navigation on mobile
		event.preventDefault();
		mainHeader.toggleClass( 'nav-open' );
	} );

	$( window ).on( 'scroll', function() {
		if ( ! scrolling ) {
			scrolling = true;
			( ! window.requestAnimationFrame )? setTimeout( autoHideHeader, 250 ): requestAnimationFrame( autoHideHeader );
		}

		var scroll = $( window ).scrollTop();

		if ( scroll >= 50 ) {
			$( '.cd-auto-hide-header' ).addClass( 'small' );
		} else {
			$( '.cd-auto-hide-header' ).removeClass( 'small' );
		}
	} );

	$( window ).on( 'resize', function() {
		headerHeight = mainHeader.height();
	} );

	function autoHideHeader() {
		var currentTop = $( window ).scrollTop();

		( belowNavHeroContent.length > 0 ) ? checkStickyNavigation( currentTop ) : checkSimpleNavigation( currentTop );

		previousTop = currentTop;
		scrolling = false;
	}

	function checkSimpleNavigation( currentTop ) {
		//there's no secondary nav or secondary nav is below primary nav
		if ( previousTop - currentTop > scrollDelta ) {
			//if scrolling up...
			mainHeader.removeClass( 'is-hidden' );
		} else if ( currentTop - previousTop > scrollDelta && currentTop > scrollOffset ) {
			//if scrolling down...
			mainHeader.addClass( 'is-hidden' );
			$( '.nav' ).removeClass( 'show' );
				$( '.menu-icon' ).removeClass( 'active' );
				$('section').css('filter', 'unset');
		}
	}

	function checkStickyNavigation( currentTop ) {
		//secondary nav below intro section - sticky secondary nav
		var secondaryNavOffsetTop = belowNavHeroContent.offset().top - secondaryNavigation.height() - mainHeader.height();

		if ( previousTop >= currentTop ) {
			//if scrolling up...
			if ( currentTop < secondaryNavOffsetTop ) {
				//secondary nav is not fixed
				mainHeader.removeClass( 'is-hidden' );
				secondaryNavigation.removeClass( 'fixed slide-up' );
				belowNavHeroContent.removeClass( 'secondary-nav-fixed' );
			} else if ( previousTop - currentTop > scrollDelta ) {
				//secondary nav is fixed
				mainHeader.removeClass( 'is-hidden' );
				secondaryNavigation.removeClass( 'slide-up' ).addClass( 'fixed' );
				belowNavHeroContent.addClass( 'secondary-nav-fixed' );
			}
		} else {
			//if scrolling down...
			if ( currentTop > secondaryNavOffsetTop + scrollOffset ) {
				//hide primary nav
				mainHeader.addClass( 'is-hidden' );
				secondaryNavigation.addClass( 'fixed slide-up' );
				belowNavHeroContent.addClass( 'secondary-nav-fixed' );
			} else if ( currentTop > secondaryNavOffsetTop ) {
				//once the secondary nav is fixed, do not hide primary nav if you haven't scrolled more than scrollOffset
				mainHeader.removeClass( 'is-hidden' );
				secondaryNavigation.addClass( 'fixed' ).removeClass( 'slide-up' );
				belowNavHeroContent.addClass( 'secondary-nav-fixed' );
			}
		}
	}
} );
